if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.resetLoadingState();
        // Reset again after layout (handles initial load without ?variant= in URL when variant-selects fetches async)
        requestAnimationFrame(() => this.resetLoadingState());
        if (document.readyState === 'complete') {
          setTimeout(() => this.resetLoadingState(), 100);
        } else {
          window.addEventListener('load', () => this.resetLoadingState(), { once: true });
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.sectionId;
          if (!sectionId || event?.data?.sectionId === sectionId) {
            this.resetLoadingState();
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      resetLoadingState() {
        const btn = this.submitButton || this.querySelector('[type="submit"]');
        if (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        }
        // Scope: product-form + parent product-info (covers ATC, BIS modal, coming-soon)
        const scope = this.closest('product-info') || this;
        scope.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.add('hidden'));
        scope.querySelectorAll('.loading-spinner-wrapper.loading').forEach((wrapper) =>
          wrapper.classList.remove('loading')
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);
        config.signal = controller.signal;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            this.retrackMonetateAddToCart(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            clearTimeout(timeoutId);
            this.resetLoadingState();
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.error && this.submitButton) this.submitButton.setAttribute('aria-disabled', true);
          });
      }

      retrackMonetateAddToCart(product) {

        fetch("/cart.js")
          .then((blob) => blob.json())
          .then((cart) => {

            if (window.monetateQ) {
              // Track the page type
              window.monetateQ.push([
                "setPageType",
                "minicart"
              ]);

              // Push the current product added to cart data
              window.monetateQ.push([
                "addProductDetails", [{
                  productId: "{{ product.product_id }}",
                  sku: "{{ product.sku }}"
                }]
              ]);

              // Grab the cart items data
              const cartRows = cart.items.map((item) => ({
                productId: String(item.product_id),
                unitPrice: (item.price / 100).toFixed(2),
                sku: item.sku,
                quantity: item.quantity,
              }));

              // Push all data from the items in the cart
              window.monetateQ.push([
                "addCartRows",
                cartRows
              ]);

              // Track all data above
              window.monetateQ.push([
                "trackData"
              ]);

            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
